import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import * as appConfig from '../../app.config';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { LoggedUser } from '../../models/shared/loggedUser.model';
import { LocalstorageService } from '../../shared/services/localstorage.service';
import { Contained } from './../../models/editors/contained.model';

export const SUCCESS_MESSAGE = 'Profilový obrázek byl úspěšně změněn!';
export const ERROR_MESSAGE = 'Změna profilového obrázku se nezdařila, zkuste to prosím znovu.';

@Component({
  selector: 'swb-profile',
  templateUrl: './profile.component.html',
  providers: [FormControlService]
})
export class ProfileComponent implements OnInit {
  public form: FormGroup;
  public get fieldsConfig(): Array<any> {
    return [
      new Contained({
        key: 'file_id',
        label: 'Profilový obrázek',
        upload: true,
        entity: this.user.file
      })
    ];
  }
  public FormEditors: any;
  public isInitialized = false;
  public isSaving = false;
  public user: LoggedUser = LocalstorageService.retrieve(appConfig.authTokenKey);

  constructor(private _formService: FormControlService,
    private _apiService: ApiService,
    private _alertService: AlertService) { }

  ngOnInit() {

    this._setupForm();
    this.isInitialized = true;

  }

  public save() {
    this.form.updateValueAndValidity();
    if (this.form.valid) {
      this.isSaving = true;
      this._apiService.post(this.form.value, 'users/profile/').subscribe(
        (response: any) => {
          if ({ ...response }.status <= 0) {
            this._alertService.error(ERROR_MESSAGE);
          } else {
            this.user.file = { ...response }.file;
            LocalstorageService.store(appConfig.authTokenKey, this.user); // store user with new profile image in localStorage
            this._alertService.success(SUCCESS_MESSAGE);
          }
          this.isSaving = false;
        },
        (error) => {
          this._alertService.error(ERROR_MESSAGE);
          this.isSaving = false;
        }
      );
    }
  }
  private _setupForm(): void {

    this.form = this._formService.toFormGroup(this.fieldsConfig.slice(), this.user);
    this.FormEditors = this._formService.toTemplateInput(this.fieldsConfig.slice(), this.user);

  }

}
